<script lang="ts">
import { defineComponent } from 'vue'
import FooterGlobal from '@/components/_core/FooterGlobal.vue'
import SolutionBreadcrumb from '../Breadcrumb.vue'
import SolutionHero from '../Hero.vue'
import SolutionDocumentsMain from './Main.vue'
import SolutionAsideSecondary from '../AsideSecondary.vue'

export default defineComponent({
  name: 'SolutionDocumentsApp',

  components: {
    FooterGlobal,
    SolutionBreadcrumb,
    SolutionHero,
    SolutionDocumentsMain,
    SolutionAsideSecondary,
  },
})
</script>

<template>
  <TemplateDefault
    :has-global-navigation="false"
    :has-search-form="false"
    :has-timeline="false">
    <template #breadcrumbHeader>
      <SolutionBreadcrumb />
    </template>

    <template #hero>
      <SolutionHero />
    </template>

    <template #main>
      <SolutionDocumentsMain />
    </template>

    <template #asideSecondary>
      <SolutionAsideSecondary />
    </template>

    <template #footer>
      <FooterGlobal
        :has-download-app="false"
        :has-follow-sns="false" />
    </template>
  </TemplateDefault>
</template>
